import { render, staticRenderFns } from "./SelectedItem.vue?vue&type=template&id=84a3d5ee&scoped=true&"
import script from "./SelectedItem.vue?vue&type=script&lang=ts&"
export * from "./SelectedItem.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SelectedItem.vue?vue&type=style&index=1&id=84a3d5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a3d5ee",
  null
  
)

export default component.exports